<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import FlagDE from '@/components/FlagDE.vue'
import FlagEN from '@/components/FlagEN.vue'

const { setLanguage } = useLayout()
const { locale, t } = useI18n()

const languages = computed(() => [
  { code: 'de', name: t('common.labels.german'), flag: FlagDE },
  { code: 'en', name: t('common.labels.english'), flag: FlagEN },
])

const selectedLanguage = ref<'de' | 'en'>(locale.value as 'de' | 'en')
const activeLanguage = computed(() =>
  languages.value.find((l) => l.code === selectedLanguage.value),
)

watch(
  () => selectedLanguage.value,
  (newLang: 'de' | 'en') => {
    setLanguage(newLang)
  },
)
</script>

<template>
  <AppSelect
    v-model="selectedLanguage"
    :options="languages"
    option-label="name"
    option-value="code"
    class="h-8"
    size="small"
  >
    <template #option="slotProps">
      <div class="flex items-center gap-2">
        <component :is="slotProps.option.flag" class="w-4" />
        <span>{{ slotProps.option.name }}</span>
      </div>
    </template>
    <template #value="slotProps">
      <div v-if="slotProps.value" class="flex gap-2">
        <component :is="activeLanguage?.flag" class="w-4" />
        <span>{{ activeLanguage?.code.toUpperCase() }}</span>
      </div>
    </template>
  </AppSelect>
</template>
